<template>
  <v-container id="order-details" fluid ma-0 pa-0>
    <v-layout row wrap ma-0 pa-0>
      <v-flex xs6>
        <component
          :is="quoteToolFlag ? 'OrderStepper2' : 'OrderStepper'"
          @orderType="onOrderType"
        ></component>
      </v-flex>
      <v-flex xs3>
        <v-title>Request</v-title>
        <v-overflow-btn
          color="primary"
          :items="request"
          label="Select from the list"
          target="#order-details"
          clearable
          @change="NewRequest"
        >
          <template slot="item" slot-scope="data">
            <v-icon class="mr-2">{{ data.item.icon }}</v-icon>
            {{ data.item.text }}
          </template>
        </v-overflow-btn>
      </v-flex>
      <v-flex xs3>
        <v-title>Resources</v-title>
        <v-menu :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn class="resource-btn" text v-on="on">
              <span>Select from the list</span>
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>

          <v-list class="mt-5">
            <div v-for="item in resources" :key="item.text">
              <div v-if="item.text === 'Learn'">
                <v-list-group>
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-icon>{{ item.icon }}</v-icon>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>

                  <v-list-tile
                    v-for="sub in item.subItem"
                    :key="sub.text"
                    class="sub-item"
                    @click="Resources(sub.value)"
                  >
                    <v-icon>{{ sub.icon }}</v-icon>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ sub.text }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
              </div>
              <div v-else>
                <v-list-tile class="resources-tile">
                  <v-icon>{{ item.icon }}</v-icon>
                  <v-list-tile-content>
                    <v-list-tile-title @click="Resources(item.value)">
                      <span>{{ item.text }}</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
            </div>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
    <training-list v-show="training" ref="trainingList"></training-list>
  </v-container>
</template>

<script>
///This component will emit order type for the creation of new orders
import TrainingList from './training-list';
import OrderStepper from '@/components/pages/create-order/order-stepper';
import OrderStepper2 from '@/components/pages/create-order/order-stepper-1723';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: mapOrderGetters } = createNamespacedHelpers(`orders`);

export default {
  name: 'OrderType',
  components: {
    TrainingList,
    OrderStepper,
    OrderStepper2,
  },
  data() {
    return {
      training: false,

      newOrder: [
        { text: 'Qantas', value: 'qantas', icon: 'airplanemode_active' },
        { text: 'Business', value: 'business', icon: 'work' },
        { text: 'Residential', value: 'residential', icon: 'house' },
      ],
      existing: [
        {
          text: 'Add non-QBR Services',
          value: 'standard',
          icon: 'mdi-plus-box-multiple',
        },
        {
          text: 'Add QBR Services to QBR Customers',
          value: 'additionalQBR',
          icon: 'mdi-layers-plus',
        },
        {
          text: 'Upgrade non-QBR services',
          value: 'upgradeQBR',
          icon: 'mdi-package-up',
        },
      ],
      request: [
        { text: 'Change of Address', value: 'coa', icon: 'mdi-map-legend' },
        { text: 'Change of Lessee', value: 'col', icon: 'mdi-account-switch' },
        {
          text: 'Service Qualification',
          value: 'sq',
          icon: 'mdi-certificate-outline',
        },
      ],
      resources: [
        { text: 'Admin', value: 'admin', icon: 'mdi-account-key' },
        {
          text: 'Sign Up to QBR',
          value: 'signUpQBR',
          icon: 'mdi-account-plus',
        },
        {
          text: 'Learn',
          value: 'learn',
          icon: 'mdi-lightbulb-outline',
          active: false,
          subItem: [
            {
              text: 'Training',
              value: 'training',
              icon: 'mdi-google-classroom',
            },
            { text: 'Knowledge Base', value: 'kb', icon: 'mdi-cogs' },
          ],
        },
        {
          text: 'Sales Resources',
          value: 'salesresources',
          icon: 'mdi-storefront',
        },
        // { text: "Products", value: "products", icon: "mdi-web" },
      ],
    };
  },
  mounted() {
    this.start = false;
  },
  methods: {
    onOrderType(val) {
      this.$emit(val);
    },
    NewOrder(val) {
      this.$emit(val);
    },
    ExistingCustomer(val) {
      this.$emit(val);
    },
    NewRequest(val) {
      if (val) {
        this.$emit(val);
      }
    },
    Resources(val) {
      let vm = this;
      vm.training = val === 'training';
      if (vm.training) {
        vm.$refs.trainingList.loadPage();
      } else {
        if (val === 'kb') window.open('https://vonex.kayako.com', '_blank');
        if (val === 'products' || val === 'salesresources')
          vm.$router.push(`resources-list/${val}`);
        if (val === 'admin')
          window.open('https://partneradmin.vonex.com.au', '_blank');
        if (val === 'signUpQBR') vm.$router.push('qantas');
      }
    },
  },
  computed: {
    ...mapOrderGetters(['quoteToolFlag']),
  },
};
</script>

<style>
.resource-btn.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  text-transform: none;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.54);
  line-height: 48px;
  height: 62px;
  width: 100%;
  text-align: left;
  border-top: 1px solid #ccc;
  margin-top: 3px;
  border-bottom: 1px solid #828282;
  padding: 0;
}
button.resource-btn div {
  justify-content: left;
  padding: 0 12px;
  align-items: left;
}
button.resource-btn div i {
  right: 5px;
}
button.resource-btn .v-btn__content span {
  width: 100%;
}
.resources-tile {
  cursor: pointer;
}
.resources-tile:hover {
  background: rgba(0, 0, 0, 0.04);
}
.v-list__tile.theme--light i {
  margin-right: 8px;
}
.sub-item {
  padding-left: 33px;
}
</style>
